import { NgModule } from '@angular/core';
import { RSCommonModule } from 'src/app/core/feature-modules/facade.module';
import { AbpDateLocationsFormComponent } from './abp-date-locations-form.component';

@NgModule({
  imports: [RSCommonModule],
  declarations: [AbpDateLocationsFormComponent],
  exports: [AbpDateLocationsFormComponent],
})
export class AbpDateLocationsFormModule {}
